import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApisService} from '../../services/apis.service';
import Swal from 'sweetalert2';


@Component({
    selector: 'notifications-cmp',
    moduleId: module.id,
    styleUrls: ['./notifications.component.css'],
    templateUrl: 'notifications.component.html'
})

export class NotificationsComponent {
  public notificationForm: FormGroup;
  loading: boolean = false;
  public typeNotification: string = ''
  public typeNotificationUser: string = ''

  constructor(
    private toastr: ToastrService,
    private form: FormBuilder,
    private apis: ApisService
  ) {

  }

  ngOnInit() {
    this.notificationForm = this.form.group({
      title: ['', {validators: [
        Validators.required,
        Validators.maxLength(30)
      ]}],
      description: ['', {validators: [
        Validators.required,
        Validators.maxLength(130)
      ]}],
    });
  }

  notificationType(check) {
    console.log('type notification: ', check)
    this.typeNotification = check
  }

  notificationTypeUser(check) {
    console.log('type notification user: ', check)
    this.typeNotificationUser = check
  }

  onSubmit() {
    const form = this.notificationForm.value;
    console.log('form notifications: ', form, this.typeNotification)
    if (this.typeNotification == 'PROD') {
      Swal.fire({
        title: 'Confirmar envio !!',
        text: '¿Estás seguro que deseas enviar notificaciones push en modo PRODUCCIÓN?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3e7932',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, envíar'
      }).then((result) => {
        if (result && result.value && result.value === true) {
          this.sendNotification()
        }
      });
    } else {
      this.sendNotification()
    }
  }

  sendNotification() {
    this.loading = true;
    const form = this.notificationForm.value;
    form['type_notification'] = this.typeNotification
    form['type_notification_user'] = this.typeNotificationUser
    this.apis.sendNotificationsPush(form).then(result => {
      if (result['status'] == 'success') {
        this.loading = false;
        this.showNotification('bottom', 'left', 'success', 'Notificación enviada correctamente.');
        setTimeout(() => {
          //location.reload();
        }, 1000);
      } else {
        this.loading = false;
        this.showNotification('bottom', 'left', 'error', 'Error al enviar notificaciones');
      }
    })
  }

showNotification(from, align, event = 'success', message = '') {
switch (event) {
  case 'info':
    this.toastr.info(
    '<span data-notify="icon" class="nc-icon nc-bell-55"></span><span data-notify="message">Bien <b>Paper Dashboard Angular</b></span>',
      "",
      {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        toastClass: "alert alert-info alert-with-icon",
        positionClass: "toast-" + from + "-" + align
      }
    );
    break;
  case 'success':
    this.toastr.success(
      '<span data-notify="icon" class="nc-icon nc-bell-55"></span><span data-notify="message"><b> ' + message + ' </b></span>',
      "Bien",
      {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        toastClass: "alert alert-success alert-with-icon",
        positionClass: "toast-" + from + "-" + align
      }
    );
    break;
  case 'warning':
    this.toastr.warning(
    '<span data-notify="icon" class="nc-icon nc-bell-55"></span><span data-notify="message">Welcome to <b>Paper Dashboard Angular</b> - a beautiful bootstrap dashboard for every web developer.</span>',
      "",
      {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        toastClass: "alert alert-warning alert-with-icon",
        positionClass: "toast-" + from + "-" + align
      }
    );
    break;
  case 'error':
    this.toastr.error(
      '<span data-notify="icon" class="nc-icon nc-simple-remove"></span><span data-notify="message"><b> ' + message + ' </b></span>',
      "Error",
      {
        timeOut: 4000,
        enableHtml: true,
        closeButton: true,
        toastClass: "alert alert-danger alert-with-icon",
        positionClass: "toast-" + from + "-" + align
      }
    );
    break;
  case 'show':
    this.toastr.show(
    '<span data-notify="icon" class="nc-icon nc-bell-55"></span><span data-notify="message">Welcome to <b>Paper Dashboard Angular</b> - a beautiful bootstrap dashboard for every web developer.</span>',
      "",
      {
        timeOut: 4000,
        closeButton: true,
        enableHtml: true,
        toastClass: "alert alert-primary alert-with-icon",
        positionClass: "toast-" + from + "-" + align
      }
    );
    break;
  default:
    break;
}
}
}
